/*Login*/
export const CHECK_EMAIL_API = "/api/Auth/check-email";
export const LOGIN_USER_API = "/api/Auth/login";
export const LOGIN_ANONYMOUS_API = "/api/Auth/SendOtp-RMS?toEmail=";
export const VALIDATE_OTP = "/api/Auth/ValidateOtp-RMS";
/*Form*/
export const SUBMIT_RESIDENT_FORM_API = "/api/RMS";
/*Manager details*/
export const GET_RMS_MGMT_INFO = "/api/RMS/GetRMSMgmtInfoByEmail";
export const UPDATE_RMS_MGMT_INFO = "/api/RMS/UpsertRMSMgmtInfo";
export const DOWNLOAD_TEMPLATE_API = "/api/RMS/resident-upload";
export const UPLOAD_EXCEL_API = "/api/RMS/UploadExcel";

//Give the Client list associated with the email
export const GET_USER_CLIENT = "/api/Auth/GetUserClients";


//Validate Client form subdomain name
export const VALIDATE_CLIENT_SUBDOMAIN = "/api/Client/ValidateClient";

export const GET_RMS_PROPERTIES = "/api/RMS/GetRMSPropertiesByClient";
export const GET_CITY = "/api/Anonymous/GetAllCity";
export const GET_RMS_PROPERTY_DETAILS = "/api/RMS/GetRMSPropertyDetails";